import React, { useEffect, useState } from 'react';
import { DateTimeService } from 'services/datetime-service';
import { RequestFormViewModel } from 'stores/requests/request-form-store';

interface RequestMainDataProps {
  selectedItem?: RequestFormViewModel;
  readOnly?: boolean;
  onChange?: (value: Partial<RequestFormViewModel>) => void;
}

const RequestMainData: React.FC<RequestMainDataProps> = ({ selectedItem, readOnly, onChange }) => {
  const borderColor = selectedItem.eventTypeColor;

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [title, setTitle] = useState(selectedItem.title || '');
  const [desiredEventDuration, setDesiredEventDuration] = useState(selectedItem.desiredEventDuration || '');

  useEffect(() => {
    setStartDate(DateTimeService.toDateInputString(selectedItem.startDate, 'YYYY-MM-DD'));
    setEndDate(DateTimeService.toDateInputString(selectedItem.endDate, 'YYYY-MM-DD'));
    setTitle(selectedItem.title || '');
    setDesiredEventDuration(selectedItem.desiredEventDuration || '');
  }, [selectedItem]);

  const handleOnChange = (value: any, property: keyof RequestFormViewModel) => {
    if (onChange) {
      onChange({ [property]: value });
    }
    if (property === 'startDate') setStartDate(value);
    if (property === 'endDate') setEndDate(value);
    if (property === 'title') setTitle(value);
    if (property === 'desiredEventDuration') setDesiredEventDuration(value);
  };

  return (
    <div className="mb-4 space-y-1">
      <div className="flex items-center gap-3">
        <div className="w-4 h-4 rounded-full flex-shrink-0" style={{ backgroundColor: borderColor }} />
        {readOnly ? (
          <h2 className="text-xl font-bold">
            {selectedItem.friendlyId} - {title}
          </h2>
        ) : (
          <input
            type="text"
            className="text-xl font-bold border border-gray-300 rounded px-2 py-1 w-full"
            value={title}
            onChange={e => handleOnChange(e.target.value, 'title')}
          />
        )}
        <p className="text-sm text-gray-700 font-medium">{selectedItem.statusDescription}</p>
      </div>
      <p className="text-sm text-gray-700 font-medium">{`Request Type: ${selectedItem.eventTypeName}`}</p>
      <p className="text-sm text-gray-700 font-medium">Desired Dates Slot</p>
      <div className="flex gap-3 mb-3">
        <input
          type="date"
          className="w-full p-2 border border-gray-300 rounded"
          placeholder="From"
          disabled={readOnly}
          value={startDate}
          onChange={e => handleOnChange(e.target.value, 'startDate')}
        />
        <input
          type="date"
          className="w-full p-2 border border-gray-300 rounded"
          placeholder="To"
          disabled={readOnly}
          value={endDate}
          onChange={e => handleOnChange(e.target.value, 'endDate')}
        />
      </div>
      <p className="text-sm">
        Request Duration:
        <input
          type="text"
          className="w-full p-2 border border-gray-300 rounded"
          placeholder="Request Duration"
          value={desiredEventDuration}
          disabled={readOnly}
          onChange={e => handleOnChange(e.target.value, 'desiredEventDuration')}
        />
      </p>
      <p className="text-sm">Request Location: {selectedItem.eventLocation.title}</p>
      <p className="text-sm">Request Reason: {selectedItem.requestReason?.title}</p>
    </div>
  );
};

export default RequestMainData;
